var isBuffer = function isBuffer() {
  return false;
};

export default (function (target, opts) {
  opts = opts || {};
  var delimiter = opts.delimiter !== undefined ? opts.delimiter : '.';
  var maxDepth = opts.maxDepth;

  var transformKey = opts.transformKey || function (key) {
    return key;
  };

  var output = {};

  var step = function step(object, prev, currentDepth) {
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      var isarray = opts.safe && Array.isArray(value);
      var type = Object.prototype.toString.call(value);
      var isbuffer = isBuffer(value);
      var isobject = type === '[object Object]' || type === '[object Array]';
      var newKey = prev ? prev + delimiter + transformKey(key, prev) : transformKey(key, prev);

      if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1);
      }

      output[newKey] = value;
    });
  };

  step(target, null, 0);
  return output;
});